import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { TellentNavigationItemBadge } from '@core/tellent-types';
import { IconComponent } from '@core/user-interface-legacy';

import { NavigationLabelBadgesComponent } from './navigation-label-badges/navigation-label-badges.component';

@Component({
  standalone: true,
  selector: 'tlc-navigation-label',
  styleUrls: ['./navigation-label.component.less'],
  host: {
    '[class.desktop-minimized]': 'minimized()',
    '[class.desktop-full]': '!minimized()',
  },
  template: `
    @let iconVal = icon();
    @let iconSvgVal = safeIconSvg();
    @let minimizedVal = minimized();
    @let badgesVal = badges();
    @let showUpgradeIconVal = showUpgradeIcon();

    @if (iconSvgVal) {
      <div class="icon icon--inline-svg" [innerHTML]="iconSvgVal"></div>
    } @else if (iconVal) {
      <div class="icon">
        <rt-icon [name]="$any(iconVal)" />
      </div>
    }

    @if (!minimizedVal) {
      <div class="label">{{ label() }}</div>
    }

    @if (badgesVal.length) {
      <tlc-navigation-label-badges [badges]="badgesVal" [minimized]="minimizedVal" />
    }

    @if (!minimizedVal && showUpgradeIconVal) {
      <div class="upgrade-icon">
        <rt-icon name="upgrade" />
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NavigationLabelBadgesComponent],
})
export class TellentNavigationLabelComponent {
  #sanitizer = inject(DomSanitizer);

  public label = input.required<string>();
  public icon = input<string | null>(null);
  public iconSvg = input<string | null>(null);
  public minimized = input<boolean>(false);
  public badges = input<TellentNavigationItemBadge[]>([]);
  public showUpgradeIcon = input<boolean>();

  public safeIconSvg = computed(() => {
    const svg = this.iconSvg();
    // eslint-disable-next-line ban/ban
    if (svg) return this.#sanitizer.bypassSecurityTrustHtml(svg);

    return null;
  });
}
